import script from "./StoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreList.vue?vue&type=script&setup=true&lang=js"

import "./StoreList.vue?vue&type=style&index=0&id=5a025614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a025614"]])

export default __exports__